import React, { useEffect, useState, useContext } from "react";

import { useForm } from "../../../../../hooks/useForm";
import { AppContext } from "../../../Context/Context";
import { useHistory } from "react-router-dom";

export const RecuperarContrasenaPaso1 = () => {
    const history = useHistory();
    const [state, setState] = useContext(AppContext);

    const [formValues, handleInputChange, reset] = useForm({
        documento: ""
    });
    const { documento } = formValues;
    const [errorDocument, seterrorDocument] = useState(null);
    const [isValid, setIsValid] = useState(false);

    let checkValues = () => {
        const regex = /^[0-9]*$/;
        const onlyNumbers = regex.test(documento);

        if (!onlyNumbers || documento.length < 8) {
            seterrorDocument("Debe tener solo números y ser mayor de 8 cifras");
        } else {
            seterrorDocument("");
        }

        if (onlyNumbers && documento.length >= 8) {
            setIsValid(true);
        } else {
            setIsValid(false);
        }
    };

    useEffect(() => {
        if (isValid) {
            handleSubmit();
        }
    }, [isValid]);

    let handleSubmit = e => {
        if (e) {
            e.preventDefault();
        }

        checkValues();

        if (isValid) {
            sessionStorage.setItem("ctLocal", btoa(documento));

            history.push("/recuperar_contrasena_ingresa_email");
        }
    };

    return (
        <div className="login">
            <div className="login_title">
                <h1>RECUPERAR CONTRASEÑA</h1>
            </div>
            <div className="login_formDiv">
                <div className="login_formDiv--desktop">
                    <div className="login_formDiv--desktop--form">
                        <form className="login_form" onSubmit={handleSubmit}>
                            <h1>RECUPERAR CONTRASEÑA</h1>
                            <p className="title mb-base">
                                Ingrese su CUIT / CUIL para recuperar la
                                contraseña.
                            </p>

                            <input
                                className={`${
                                    errorDocument != null && errorDocument != ""
                                        ? "login_form--input errorInput"
                                        : "login_form--input"
                                } `}
                                placeholder="CUIT / CUIL"
                                name="documento"
                                value={documento}
                                onChange={handleInputChange}
                            />
                            <p
                                className={`${
                                    errorDocument != null && errorDocument != ""
                                        ? "errorMsgInput"
                                        : ""
                                } `}
                            >
                                {errorDocument}
                            </p>

                            <button
                                className="login_form--button mt-base"
                                type="submit"
                            >
                                <p>
                                Enviar
                                </p>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};
